/**
 * @format
 */
import { AppRegistry, Platform } from 'react-native';
import './web-shims';
import { name as appName } from './app.json';
import { DependencyContainer } from './DependencyContainer';

AppRegistry.registerComponent(appName, () => DependencyContainer);

if (Platform.OS === 'web') {
  AppRegistry.runApplication(appName, {
    rootTag: document.getElementById('root'),
  });
}
